/* eslint-disable prettier/prettier */
export const standard = {
	standards: {
    stanvals: {
		0: '',
		5: '0.5,10',
		10: '1,10',
		15: '1.5,10',
		20: '2,10',
		25: '2.5,10',
		30: '3,10',
		35: '3.5,10',
		40: '4,10',
		45: '4.5,10',
		50: '5,10',
		55: '5.5,10',
		60: '6,10',
		65: '6.5,10',
		70: '7,10'
    },
    stans: {
		0: 'Dowolny',
		5: 'Od 0.5 *',
		10: 'Od 1 *',
		15: 'Od 1,5 *',
		20: 'Od 2 *',
		25: 'Od 2,5 *',
		30: 'Od 3 *',
		35: 'Od 3,5 *',
		40: 'Od 4 *',
		45: 'Od 4,5 *',
		50: 'Od 5 *',
		55: 'Od 5,5 *',
		60: 'Od 6 *',
		65: 'Od 6,5 *',
		70: 'Od 7 *'
    }
	}
}
